import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOculusComponent } from './simple-icons-oculus.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOculusComponent ],
    exports:      [ SimpleIconsOculusComponent ],
    bootstrap:    []
})
export class SimpleIconsOculusModule {}
